const initialState = {
  count: 0,
  items: [],
  images_data: [],
  money_orders: '', // Khởi tạo chuỗi rỗng
  price_orders: '', // Khởi tạo chuỗi rỗng
  users_view_max: 1000, // Khởi tạo chuỗi rỗng
  scams_lists_search: [], // Khởi tạo chuỗi rỗng
  scams_lists_show: false, // Khởi tạo chuỗi rỗng
  accounts_search_results: [], // Khởi tạo chuỗi rỗng
  blob_data: '', // Khởi tạo chuỗi rỗng
  amount_orders: '', // Khởi tạo chuỗi rỗng
  discount_orders: '', // Khởi tạo chuỗi rỗng
  category_pro_max: [], // Khởi tạo chuỗi rỗng
  category_pro_lite: [], // Khởi tạo chuỗi rỗng
  category_service: '', // Khởi tạo chuỗi rỗng
  comments_orders: '', // Khởi tạo chuỗi rỗng
  username_orders: '', // Khởi tạo chuỗi rỗng
  input_url_orders: '', // Khởi tạo chuỗi rỗng
  shop_insurance: '', // Khởi tạo chuỗi rỗng
  national_market: '', // Khởi tạo chuỗi rỗng
  latest_version: false, // Khởi tạo chuỗi rỗng
  open_button_support: false, // Khởi tạo chuỗi rỗng
  upload_videos_check: false, // Khởi tạo chuỗi rỗng
  accounts_load_show: false, // Khởi tạo chuỗi rỗng
  media_link_url: '', // Khởi tạo chuỗi rỗng
  tiktok_users_id: '', // Khởi tạo chuỗi rỗng˝
  media_link_tik: '', // Khởi tạo chuỗi rỗng
  media_id_users: '', // Khởi tạo chuỗi rỗng˝
  api_response: '', // Khởi tạo chuỗi rỗng
  users_status: '', // Khởi tạo chuỗi rỗng
  stable_coins: '', // Khởi tạo chuỗi rỗng
  stable_coins: '', // Khởi tạo chuỗi rỗng
  services_categorys: [
    {
      id: "",
      stt: "",
      name: "Please wait a moment 😊 đang tải dịch vụ",
      money: "",
      status: "show",
      content: "",
      servicecode: "",
    },
  ], // Khởi tạo chuỗi rỗng
  services_orders: [
    {
      id: "",
      stt: "",
      name: "Please wait a moment 😊 đang tải dịch vụ",
      money: "",
      status: "show",
      content: "",
      servicecode: "",
    },
  ]
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INCREMENT':
      return {
        ...state,
        count: state.count + 1,
      };
    case 'DECREMENT':
      return {
        ...state,
        count: state.count - 1,
      };
    case 'add_money_orders':
      return {
        ...state,
        money_orders: state.money_orders + action.payload, // Thêm mục mới vào cuối chuỗi
      };
    case 'remove_money_orders':
      return {
        ...state,
        money_orders: state.money_orders.replace(action.payload, ''), // Xóa mục khỏi chuỗi
      };
    case 'update_money_orders':
      return {
        ...state,
        money_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_price_orders':
      return {
        ...state,
        price_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_users_view_max':
      return {
        ...state,
        users_view_max: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_scams_lists_search':
      return {
        ...state,
        scams_lists_search: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_scams_lists_show':
      return {
        ...state,
        scams_lists_show: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_accounts_search_results':
      return {
        ...state,
        accounts_search_results: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_amount_orders':
      return {
        ...state,
        amount_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_api_response':
      return {
        ...state,
        api_response: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_discount_orders':
      return {
        ...state,
        discount_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_category_pro_lite':
      return {
        ...state,
        category_pro_lite: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_accounts_load_show':
      return {
        ...state,
        accounts_load_show: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_category_pro_max':
      return {
        ...state,
        category_pro_max: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_items_info':
      return {
        ...state,
        items_info: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_category_service':
      return {
        ...state,
        category_service: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_services_categorys':
      return {
        ...state,
        services_categorys: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_services_orders':
      return {
        ...state,
        services_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_comments_orders':
      return {
        ...state,
        comments_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_open_button_support':
      return {
        ...state,
        open_button_support: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_upload_videos_check':
      return {
        ...state,
        upload_videos_check: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_media_link_url':
      return {
        ...state,
        media_link_url: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_media_link_phone':
      return {
        ...state,
        media_link_phone: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_tiktok_users_id':
      return {
        ...state,
        tiktok_users_id: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_media_link_tik':
      return {
        ...state,
        media_link_tik: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_username_orders':
      return {
        ...state,
        username_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_input_url_orders':
      return {
        ...state,
        input_url_orders: action.payload, // Cập nhật chuỗi với giá trị mới
      };

    case 'update_shop_insurance':
      return {
        ...state,
        shop_insurance: action.payload, // Cập nhật chuỗi với giá trị mới
      };

    case 'update_users_status':
      return {
        ...state,
        users_status: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_stable_coins':
      return {
        ...state,
        stable_coins: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_images_data':
      return {
        ...state,
        images_data: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_blob_data':
      return {
        ...state,
        blob_data: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_national_market':
      return {
        ...state,
        national_market: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'update_latest_version':
      return {
        ...state,
        latest_version: action.payload, // Cập nhật chuỗi với giá trị mới
      };
    case 'ADD_ITEM':
      return {
        ...state,
        items: [...state.items, action.payload],
      };
    case 'REMOVE_ITEM':
      return {
        ...state,
        items: state.items.filter((item, index) => index !== action.payload),
      };
    default:
      return state;
  }
};

export default rootReducer;
